import { render } from "./Art.vue?vue&type=template&id=62472d3f&scoped=true&ts=true"
import script from "./Art.vue?vue&type=script&lang=ts"
export * from "./Art.vue?vue&type=script&lang=ts"

import "./Art.vue?vue&type=style&index=0&id=62472d3f&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\abelh\\.projects\\koko_v1\\koko_v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62472d3f"]])

export default __exports__